import { RuntimeEnvironments, MSAEnvironments } from './runtime-environments';

export const environment = {
  production: true,
  performance: false,
  internal: true,
  deployment: 'production',
  site: 'retailInternal',
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  SYS_LEVEL: 'PROD',
  GLOBAL_HEADER_V8_JS: "https://n4v-i.web.vanguard.com/secure-site-components.js",

  LOGON_URL: 'https://idpi.retailgeneral2p.c1.vanguard.com/api/tpe-consumer-webapp/auth?logonTargetUrl=https://thirdparty-documents-i.web.vanguard.com',
  MEDALLIA_LIB:
    'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/external_libs/wdcusprem/2940/onsite/medallia-digital-embed.js',
  SECURE_MESSAGE_URL: 'https://personal.vanguard.com/us/SMCInformationCenter',
  // CONSUMER_API: 'https://api.ecs.us-east-1.rett.c1.vanguard.com/xs1-secure-site-consumer-api/',
  // GRAPHQL_URI: 'https://apps.ecs.retp.c1.vanguard.com/xs1-secure-site-consumer-api/graphql',
  LEGACY_URL: 'https://oedesktop.vanguard.com/us/AddrViewController',
  GATEKEEPER_FEATURE_ID: 'TPDLegacyRedirect',
  ES529_SSO_FALLBACK_URL: 'https://personal.vanguard.com/us/CS529SsoToUIIController?Nav=INTP&529entry=myprofile_address_529only',
  GATEKEEPER_529_SSO_FEATURE_ID: 'TPQ-529-Asensus-SSO-Toggle',

  FLOODLIGHT_RTE: RuntimeEnvironments.PROD,
  MSA_ENVIRONMENT: MSAEnvironments.PRODUCTION,
  PERSONAL_DOMAIN: 'https://personal.vanguard.com',
  ADOBE_TARGET_ANTIFLICKER_JS:
    'https://corp.at2.assets.vgdynamic.info/files/js/core/antiflicker.min.js',
  C3_SERVERLESS_BUNDLE_JS:
    "https://mc3-static-assets.web.vanguard.com/vg-ccc-serverless/latest/vg-ccc-serverless.js",
  ENROLL_IN_E_DELIVERY:
    'https://idpi.retailgeneral2p.c1.vanguard.com/np2-delivery-settings-ui',
  VIEW_STATEMENTS:
    'https://statements-i.web.vanguard.com',
  VISIT_TAX_CENTER:
    'https://taxcenter.i.web.vanguard.com/tax-center',
  THIRDPARTY_DOCUMENTS: {
    BASE_URL: 'https://idpi.retailgeneral2p.c1.vanguard.com/api/tpe-consumer-webapp',
    GET_ADDRESSES: '/thirdparty-documents/addresses',
    STATES: '/thirdparty-documents/states',
    COUNTRIES: '/thirdparty-documents/countries',
    LOGGER: '/client-log',
    CAAS_URL: '/thirdparty-documents/caas',
    GATEKEEPER_URL: '/gatekeeper',
    ADD_ADDRESS: '/thirdparty-documents/addaddress',
    UPDATE_ADDRESS: '/thirdparty-documents/updateaddress',
    DELETE_ADDRESS: '/thirdparty-documents/deleteaddress',
    ACCOUNTS: '/thirdparty-documents/accounts',
    GROUPS: '/thirdparty-documents/groups',
    INTERNAL_URL: 'https://thirdparty-documents-i.web.vanguard.com?secureMessage=true'
  }
};
